import React, { useState, useEffect } from "react";
import { API_ENDPOINTS } from "@/src/config/api.js";

const Quote = () => {

  let [responseData, setResponseData] = useState("");
  const fetchData = React.useCallback(() => {
    fetch(API_ENDPOINTS.quotes.latest)
      .then(response => response.json())
      .then((response) => {
        setResponseData(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  useEffect(() => {
    fetchData();
  }, []);
  const truncateWithEllipses = (text, max) => {
    return text.substr(0, max - 1) + (text.length > max ? "..." : "");
  };
  if (responseData && responseData.quote) {
    const quote = responseData.quote;
    return (
      <div className="bg-neutral-900 rounded-lg p-4">
        <h2 className="font-bold text-lg mb-2">QUOTE OF THE DAY</h2>
        {/* <p class="text-sm text-gray-300">Daily discussions about music, culture, and
        everything
        in between.</p> */}
        <p className="text-lg">
          <span>&#8220; <a href="/quotes">{truncateWithEllipses(quote.quote, 230)}</a>&#8221;</span> - {quote.quoted}
        </p>
        <div className="mt-3">
          <p>(Submitted by {quote.user})</p>

        </div>
      </div>
    )
  }
  else {
    return <div>Loading...</div>;
  }
}


export default Quote;
